// src/App.tsx
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/AuthContext';
import { RecipeProvider } from './context/RecipeContext';
import { PortalProvider } from './context/PortalContext';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RecipeProvider>
          <PortalProvider>
            <AppRoutes />
          </PortalProvider>
        </RecipeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;